module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ShareModal"
  }, [_c('transition', {
    attrs: {
      "name": "ShareModal-items-"
    }
  }, [_c('share-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "ShareModal-items"
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ShareModal-background-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "ShareModal-background",
    on: {
      "click": _vm.close
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4845ca0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShareModal.vue
// module id = 764
// module chunks = 1474